<h2 mat-dialog-title>Cargar documento</h2>
<div mat-dialog-content>
  <form class="form-horizontal" [formGroup]="form">
    <div>
      <mat-form-field class="full-width-field">
        <mat-label>Tipo de Documento</mat-label>
        <mat-select formControlName="documentType">
          <mat-option value="DOC_IDENTIDAD_ASEGURADO">Documento Identidad (Asegurado)</mat-option>
          <mat-option value="DOC_IDENTIDAD_BENEFICIARIO">Documento Identidad (Beneficiario)</mat-option>
          <mat-option value="TARJETA_PROPIEDAD">Tarjeta de Propiedad</mat-option>
          <mat-option value="FACTURA">Factura de compra *nuevo</mat-option>
          <mat-option value="INSPECCION">Inspección</mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls['documentType'].hasError('required')">Requerido</mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="full-width-field">
        <mat-label>Descripción</mat-label>
        <input matInput formControlName="description">
        <mat-error *ngIf="form.controls['documentType'].hasError('required')">Requerido</mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="full-width-field">
          <input type="file" id="fileInput" formControlName="fileContent"
                 (change)="selectFile($event)" name="fileInput"/>
          <input matInput [value]="fileName" />
      </mat-form-field>
    </div>
    <div *ngIf="data.documentTypes.includes(form.controls['documentType'].value)" class="message"> El tipo de documento sera remplazado</div>
    <div *ngIf="message" class="message"> {{ message }}</div>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancelar</button>
  <button mat-button (click)="createClick()" [disabled]="uploading">Aceptar</button>
</div>
